/**
 * Onde as telas da mensalidade existem, até o PM liberar.
 *
 * 🚨 PELO BANCO DO BUILD, E NÃO PELO ENDEREÇO DO SITE. O `hideInProducao` do
 * menu decide pelo endereço: some só em creditos.invenia.com.br. Mas o beta e
 * as urls próprias de cada publicação (`*.creditos-v2.pages.dev`) falam com o
 * MESMO banco da produção, com gestores e boletos reais (revisão T-078,
 * SEG-B5b-001). Aqui a régua é a do `CrashProbe`: só o build ligado ao banco de
 * ensaio (o alfa, pelo `vite.config.ts`) mostra as telas. Qualquer outro banco,
 * ou banco nenhum, esconde: na dúvida, não aparece.
 *
 * Para liberar na produção, depois de o servidor da mensalidade estar
 * publicado e com a autorização do PM: `LIBERADA_PELO_PM = true`. Um lugar só,
 * que vale para os itens do menu e de Configurações, as rotas, os
 * redirecionamentos, o `?unidade` da página de Pagamento e os avisos.
 *
 * Pedido do PM de 07/10/2026 (tarefa `wdwxndz4jp`): validar fora do ensaio,
 * antes da liberação geral, com um grupo controlado — quem opera a cobrança da
 * rede (`super_admin` e `network_manager`). `LIBERADA_PARA_QUEM_OPERA` abre as
 * mesmas quatro frentes só para esse papel; quem administra a unidade
 * (`tenant_admin`) continua sem ver nada fora do ensaio até `LIBERADA_PELO_PM`.
 */

/** O banco de ensaio, o único com que as telas existem antes da liberação. */
export const BANCO_DE_ENSAIO = "rniqafkbcwihovbpcvid.supabase.co"

/** A liberação do PM para todos os ambientes. Hoje, não. */
export const LIBERADA_PELO_PM = false

/** A liberação do PM só para quem opera a cobrança da rede. Hoje, sim. */
export const LIBERADA_PARA_QUEM_OPERA = true

/** Quem opera a cobrança da mensalidade da rede (decisão do PM de 30/09/2026). */
function operaACobranca(papel: unknown): boolean {
  return papel === "super_admin" || papel === "network_manager"
}

/** As telas da mensalidade existem neste build? Sem olhar o papel de quem vê. */
export function mensalidadeNoAr(urlDoBanco: unknown = import.meta.env.VITE_SUPABASE_URL): boolean {
  if (LIBERADA_PELO_PM) return true
  if (typeof urlDoBanco !== "string") return false
  try {
    return new URL(urlDoBanco).hostname === BANCO_DE_ENSAIO
  } catch {
    return false
  }
}

/**
 * As telas da mensalidade existem para ESTE papel? No ensaio e com
 * `LIBERADA_PELO_PM`, para todo mundo, como `mensalidadeNoAr`. Fora dos dois,
 * só para quem opera a cobrança (`LIBERADA_PARA_QUEM_OPERA`): o resto continua
 * fechado, inclusive sem o banco resolvido (na dúvida, não aparece).
 */
export function mensalidadeNoArParaPapel(papel: unknown, urlDoBanco: unknown = import.meta.env.VITE_SUPABASE_URL): boolean {
  if (mensalidadeNoAr(urlDoBanco)) return true
  return LIBERADA_PARA_QUEM_OPERA && operaACobranca(papel)
}
